import React, {useCallback, useEffect, useRef} from 'react'

import {DATA_LAYER_CUSTOM_EVENT} from './DataLayer.consts'
import {GTMData} from './DataLayer.types'

type Props = {
  link: string
}

declare global {
  type Window = {
    dataLayer: GTMData[]
  }
}

const DataLayer: React.FC<Props> = ({link}) => {
  const iframe = useRef<any>(null)

  // Отправка данных в iframe
  const sendData = (data: GTMData) => iframe.current?.contentWindow.postMessage(JSON.stringify(data), '*')

  const listener = useCallback((event: CustomEvent<GTMData>) => sendData(event.detail), [])

  const onPostMessagePingPong = useCallback(
    (event: MessageEvent) => {
      if (event.data === 'readyForMessage') {
        document.addEventListener(DATA_LAYER_CUSTOM_EVENT, listener as EventListener)
        if (window.dataLayer) {
          // пушим все, что накопилось
          window.dataLayer.forEach(sendData)
        }
        // пинг-понг отработал - убираем прослушку
        window.removeEventListener('message', onPostMessagePingPong)
      }
    },
    [listener],
  )

  useEffect(() => {
    window.addEventListener('message', onPostMessagePingPong)
    // пингуем на всякий - в случае если мы прослушали его первое обращение
    // $FlowFixMe
    iframe.current.contentWindow.postMessage('ready', '*')
  }, [onPostMessagePingPong])

  return (
    <noindex>
      {/* eslint-disable jsx-a11y/iframe-has-title */}
      <iframe ref={iframe} src={`${link}?v=${Date.now()}`} style={{display: 'none', visibility: 'hidden'}} />
    </noindex>
  )
}

export default DataLayer
